module.exports = __webpack_public_path__ + "bg_pracamaior.png?52c3c8f3da8ae8a192a2c0c7ac8eac4c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_pracamaior.png
// module id = 25
// module chunks = 0